import {
  ListPersonTypesResponseDto
} from '@features/setting/application/use_cases/list-person-types/dto/list-person-types.response.dto';
import {
  ListPersonTypesPayloadDto
} from '@features/setting/application/use_cases/list-person-types/dto/list-person-types.payload.dto';

import {
  ListPersonTypesHttpResponseDto
} from '@features/setting/infrastructure/http/list-person-types/list-person-types.http.response.dto';
import {
  ListPersonTypesHttpPayloadDto
} from '@features/setting/infrastructure/http/list-person-types/list-person-types.http.payload.dto';

export class ListPersonTypesHttpMapper {

  static toResponse(data: ListPersonTypesHttpResponseDto): ListPersonTypesResponseDto {
    return {
      data: data.data.map(item => ({
        id: item.code,
        code: item.code,
        label: item.name,
        abbreviation: item.abbreviation,
      }))
    }
  }

  static toInfra(data: ListPersonTypesPayloadDto): ListPersonTypesHttpPayloadDto {
    return {}
  }

}
